'use strict';

angular.module('metabuyer.services.costcenters', ['ngResource'])
  .factory('CostCenters', function($resource, $filter, pathConstants){
    var CostCenters = $resource(
      pathConstants.apiUrls.costCenters.single,
      {
        id: '@id'
      },
      {
        'put': { method: 'PUT' },
        'get': { method: 'GET' },
        'delete': { method: 'DELETE' }
      }
    );

    return CostCenters;
  })
  .factory('AddCostCenters', function($resource, $filter, pathConstants){
    var AddCostCenters = $resource(
      pathConstants.apiUrls.costCenters.new,{},
      {
        'put': { method: 'PUT' },
        'post': { method: 'POST' }
      }
    );

    return AddCostCenters;
  });
